import React, { useState, useCallback, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  MasterDetail,
  Button,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import TextField from "@material-ui/core/TextField";
import swal from "sweetalert";
import axios from "axios";
import Guid from "devextreme/core/guid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CompaignMasterDetailView from "./CompaignMasterDetailView";
import useDeviceSize from "../../hooks/useDeviceSize";
import AddCampaignModal from "./AddCampaignModal";
import { api_path } from "../../shared.js";
import DateBox from "devextreme-react/date-box";
export function CampaignManagementDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [modeSize, setModeSize] = useState("widget");
  const classes = useStyles();
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [getEmpID, setEmpID] = useState(props.EMP_CODE);

  const [selectTag, setSelectTag] = useState([]);
  const [getTag, setTag] = useState([]);
  const buList = [
    { value: "AIR", label: "AIR" },
    { value: "FOOD", label: "FOOD" },
    { value: "TIRE", label: "TIRE" },
    { value: "REEFER", label: "REEFER" },
    { value: "ISOTANK", label: "ISOTANK" },
    { value: "SOC", label: "SOC" },
    { value: "WORLDWIDE", label: "WORLDWIDE" },
    { value: "SALES", label: "SALES" },
    { value: "SEA TP", label: "SEA TP" },
    { value: "SEA NON-TP", label: "SEA NON TP" },
     { value: "IMPORT", label: "IMPORT" },
    { value: "LCL", label: "LCL" },
  ];
  const [getCampaignList, setCampaignList] = useState([]);
  const [selectCampaign, setSelectCampaign] = useState([]);
  const [getCampaign, setCampaign] = useState([]);
  const [getLoadGrid, setLoadGrid] = useState();
  const [getStatus, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const statusList = [
    { value: "1", label: "Active" },
    { value: "2", label: "Ended" },
  ];
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), 0, 1); // ✅ 1 มกราคมของปีนี้
  var lastDay = new Date(date.getFullYear(), 11, 31); // ✅ 31 ธันวาคมของปีนี้

  const [getMinDate, setMinDate] = useState(null);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const onValueChangedDateFrom = React.useCallback((e) => {
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  const pageSizes = [25, 50, 100];
  const token = process.env.REACT_APP_API_TOKEN;
  const url = `${api_path}/customer/campaigns.php?name=${selectCampaign}&tag=${selectTag}&status=${selectStatus}&datefrom=${getDateFrom}&dateto=${getDateTo}`;

  const dataSource = createStore({
    key: "CAMPAIGN_ID",
    loadUrl: url,
    reshapeOnPush: true,
    onBeforeSend(method, ajaxOptions) {
      ajaxOptions.crossDomain = true;
      ajaxOptions.xhrFields = { withCredentials: true };
      ajaxOptions.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    },
  });

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      const clickableCols = [
        "DELIVERED",
        "RECEIVED",
        "QUOTATION",
        "Close_Won",
        "NA",
      ];

      if (clickableCols.includes(e.column.dataField)) {
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        e.cellElement.style.color = "#007bff";

        e.cellElement.addEventListener("click", () => {
          setSelectedMetric(e.column.dataField);
          setSelectedCampaignId(e.data.CAMPAIGN_ID);
        });
      }

      if (e.column.dataField === "CAMPAIGN_STATUS_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button badge badge-status-" +
          e.data.CAMPAIGN_STATUS_NAME.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.CAMPAIGN_STATUS_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "CAMPAIGN_TYPE") {
        e.cellElement.innerHTML =
          "<span class='status-button badge badge-type-" +
          e.data.CAMPAIGN_TYPE.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View' target='_blank' style='color: #FFFFFF;'>" +
          e.data.CAMPAIGN_TYPE +
          "</a></span>";
      }
      if (e.column.dataField === "CHANNEL") {
        e.cellElement.innerHTML =
          "<span class='status-button badge badge-channel-" +
          e.data.CHANNEL.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.CHANNEL +
          "</a></span>";
      } else if (
        e.column.dataField === "CAMPAIGN_" &&
        e.data.CHANNEL == "Follow up"
      ) {
        e.cellElement.innerHTML =
          "<span class='status-button tag-followup'><a href='Customer?customer_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.CHANNEL +
          "</a></span>";
      }
    }
  };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Campaign.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const navigate = useNavigate();

  const onEditButtonClick = (rowData) => {
    const url = "/s-crm/CampaignDetail?id=" + rowData.CAMPAIGN_ID;
    window.open(url, "_blank"); // _blank = เปิด tab ใหม่
  };
  const onDeleteButtonClick = (rowData) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this data?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteRow(rowData.CAMPAIGN_ID);
      }
    });
  };

  const deleteRow = async (id) => {
    try {
      const response = await axios.delete(
        `${api_path}/customer/campaigns.php?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLoadGrid(Math.floor(Math.random() * 20) + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const onRefreshClick = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleSearch = (e) => {
    //setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleClearInputClick = () => {
    setStatus([]);
    setSelectStatus([]);
    setCampaign([]);
    setSelectCampaign([]);
    setTag([]);
    setSelectTag([]);
  };
  const handleAddButtonClick = React.useCallback((e) => {
    window.open("/s-crm/CampaignDetail", "_blank");
  }, []);

  const handleTagChange = (obj) => {
    setSelectTag(Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []);
    setTag({
      value: obj.value,
      label: obj.label,
    });
  };

  useEffect(() => {
    const getCampaignDropdown = async () => {
      try {
        const resstate = await fetch(api_path + `/customer/campaigns.php?getname=1`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // ใส่ token ตรงนี้
          },
        });

        if (!resstate.ok) {
          throw new Error("Network response was not ok");
        }

        const getst = await resstate.json();
        setCampaignList(getst);
      } catch (error) {
        console.error("Fetch campaign error:", error);
      }
    };

    getCampaignDropdown();
  }, []);

  const handleCampaignChange = (obj) => {
    setSelectCampaign(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setCampaign({
      value: obj.value,
      label: obj.label,
    });
  };
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <label className="head">Campaign Management</label>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleAddButtonClick}
          >
            New Campaign
          </Button1>
          {/* <AddCampaignModal
          /> */}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>CAMPAIGN NAME</label>
          <MultiSelect
            className="multiselect1"
            options={getCampaignList}
            value={getCampaignList.filter((obj) =>
              selectCampaign.includes(obj.value)
            )}
            onChange={handleCampaignChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>TAG</label>
          <MultiSelect
            className="multiselect2"
            options={buList}
            value={buList.filter((obj) => selectTag.includes(obj.value))}
            onChange={handleTagChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>STATUS</label>
          <Select
            defaultValue={"-"}
            className="multiselect3"
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Start Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          {/* <div style={{ paddingTop: 7+ "px" }}>&nbsp;</div> */}
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        {/* <Grid item xs={12}>
          Delivered:จำนวน Leads ที่ถูกส่งต่อให้เซลส์จากแคมเปญ ,Received:จำนวน
          Leads ที่เซลส์รับเข้าระบบแล้ว (เช่น กด "รับงาน") , Achieved /
          Won:จำนวน Leads ที่ปิดการขายได้สำเร็จ
        </Grid> */}
        <DataGrid
          id="CustomerContainer"
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="CAMPAIGN_ID"
          onExporting={onExporting}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
          remoteOperations={false}
        >
          <Paging enabled={true} />
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          {/* <MasterDetail enabled={true} component={CompaignMasterDetailView} /> */}
          <MasterDetail
            enabled={true}
            render={(detail) => (
              <CompaignMasterDetailView
                data={detail.data}
                selectedMetric={selectedMetric}
                selectedCampaignId={selectedCampaignId}
              />
            )}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="CAMPAIGN_ID" caption="ID" />
          <Column dataField="CAMPAIGN_NAME" caption="Campaign" />
          <Column dataField="START_DATE" caption="Start Date" />
          <Column dataField="END_DATE" caption="End Date" />
          <Column dataField="CAMPAIGN_STATUS_NAME" caption="Status" />
          <Column dataField="CAMPAIGN_TAG" caption="Tag" />
          <Column dataField="DELIVERED" caption="Delivered" />
          <Column dataField="RECEIVED" caption="Received" />
          <Column dataField="QUOTATION" caption="Quotation" />
          <Column dataField="Close_Won" caption="Close(Win)" />
          <Column dataField="NA" caption="N/A" />
          <Column
            caption="Edit"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "GRAY",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Edit Campaign"
                    onClick={() => onEditButtonClick(cellData.data, "EDIT")}
                  >
                    <span
                      className="dx-icon dx-icon-edit"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <Column
            caption="Del"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              const isShow = cellData.data.CAMPAIGN_STATUS === "0"; // โชว์ปุ่มเฉพาะ status = 0

              if (!isShow) {
                return null; // ❌ ไม่ต้องโชว์อะไรเลย
              }

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#F44336",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Delete Campaign"
                    onClick={() => onDeleteButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-trash"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />

          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />
            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />
            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
